import React, { useState, useEffect } from 'react'
import * as FlexWebChat from '@twilio/flex-webchat-ui'

import Interactives from './components/Interactives'

const App = ({ configuration }) => {
  const [manager, setManager] = useState(null)

  useEffect(() => {
    const getManager = async () => {
      const manager = await FlexWebChat.Manager.create(configuration)
      
      manager.strings.PredefinedChatMessageBody = "¡Bienvenido a Tutobot UPAEP!";
      manager.strings.InputPlaceHolder = "Escribe tu mensaje.";
      manager.strings.PredefinedChatMessageAuthorName = "Tutobot";
      manager.strings.EntryPointTagline = "Contactanos";
      manager.strings.MessageCanvasTrayButton = "Iniciar una nueva conversación";
      // Changing the Welcome message
      manager.strings.WelcomeMessage = "Bienvenido a nuestro agente virtual Tutobot";
      FlexWebChat.MessageList.Content.add(
        <Interactives
          key="interactives"
          manager={manager}
        />
      )
  
      setManager(manager)
    }
    getManager()
  }, [configuration])

  

  if (!manager) return <></>

  return (
    <FlexWebChat.ContextProvider manager={manager}>
      <FlexWebChat.RootContainer />
    </FlexWebChat.ContextProvider>
  )
}

export default App
